import { giphyBlue, giphyGreen, giphyPurple, giphyYellow } from '@giphy/colors'

const userTypeColors: Record<string, string> = {
    creator: giphyPurple,
    partner: giphyBlue,
    artist: giphyGreen,
    user: giphyYellow,
}

export const getUserTypeColor = (userType?: string, isCommunity = false): string | undefined => {
    const displayUserType = isCommunity ? 'creator' : userType?.toLowerCase()
    return displayUserType ? userTypeColors[displayUserType] : undefined
}
